export const Props = () => ({
  //ID поста, к которому относятся комментарии
  postId: {
    type: Number,
    required: false,
  },

  //ID сигнала, к которому относится комментарии
  signalId: {
    type: Number,
    required: false,
  },

  //Где рендериться список комментариев? (В попапе или на странице)
  commentsPlace: {
    type: String,
    required: true,
    validator: (value) => {
      const allowedTypes = ['popup', 'page'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'commentsPlace' в компоненте CommentsForm может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  }
});